import { createSlice } from '@reduxjs/toolkit';

interface AlertState {
	hasActiveAlert: boolean;
}

const initialState: AlertState = {
	hasActiveAlert: false
};

export const AlertSlice = createSlice({
	name: 'alert',
	initialState,
	reducers: {
		deactivateAlertStatus: (state) => {
			state.hasActiveAlert = false;
		},
		activateAlertStatus: (state) => {
			state.hasActiveAlert = true;
		}
	}
});
